import React from 'react'
import Button from 'elements/Button/index.js'
import IconGH from 'assets/images/icons/IconGH.png'

export default function IconText() {
    return (
        <Button className='navbar-brand' href='/' type='link'>
            <img src={IconGH} alt="Icon GH" width={100} />
        </Button>
    )
}
